import { createAsyncThunk } from '@reduxjs/toolkit';
import { feathersClient } from '../../../client';
import { toastHandler } from '../../../utils/toastHandler';
import { Values, WhatsAppOTPValues } from './interface';

export const authenticateUser = createAsyncThunk(
  'auth/authenticateUser',
  async (values: Values, { rejectWithValue }) => {
    try {
      const response = await feathersClient.authenticate(values);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const logoutUser = createAsyncThunk('auth/logoutUser', async (_, { rejectWithValue }) => {
  feathersClient
    .logout()
    .then((_) => {
      return;
    })
    .catch((err: any) => {
      toastHandler(err);
      rejectWithValue(err.message);
    });
});


export const authenticateWhatsAppOtpUser = createAsyncThunk(
  'auth/authenticateUser',
  async (values: WhatsAppOTPValues, { rejectWithValue }) => {
    try {
      const response = await feathersClient.authenticate(values);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);



